import { combineReducers } from "redux";
import { authReducer } from "./reducers/authReducer";
import { mobileMenuReducer } from "./reducers/mobileMenuReducer";
import { verifierReducer } from "./reducers/verifier";

const rootReducer = combineReducers({
  auth: authReducer,
  mobileMenu: mobileMenuReducer,
  verifier: verifierReducer,
});

export default rootReducer;
